import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./properties-search-zoning.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./properties-search-zoning.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { PropertiesConstants } from "../../properties.constants";
import { PropertySearchService } from "../../shared/services/property-search.service";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
let PropertiesSearchZoningComponent = class PropertiesSearchZoningComponent {
    propertySearchService;
    appController;
    changeDetectorRef;
    advancedSearchOccurred = new EventEmitter();
    propertiesZoningLabel = PropertiesConstants.FORM_CONTROLS.propertiesZoningLabel;
    propertiesZoningFormControl = PropertiesConstants.FORM_CONTROLS.propertiesZoningFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = PropertiesConstants.FORM_CONTROLS.searchText;
    propertiesZoningForm;
    propertyZonings = [];
    propertySearchCallback;
    setUpFormSubscription;
    constructor(propertySearchService, appController, changeDetectorRef) {
        this.propertySearchService = propertySearchService;
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchPropertiesZoning($event) {
        const zoning = this.propertiesZoningForm.get(this.propertiesZoningFormControl).value;
        if (zoning !== "") {
            // @ts-ignore
            this.propertySearchCallback(this.propertySearchService.searchByZoning(zoning));
        }
        else {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
        }
    }
    setUpForm() {
        this.propertiesZoningForm = new FormGroup({
            propertiesZoningFormControl: new FormControl("")
        });
        this.setUpFormSubscription = this.propertySearchService.zoningLookupListAsObservable
            .subscribe((lookups) => {
            lookups.value.forEach((lookup) => {
                if (lookup.name === PropertiesConstants.ZONING_LOOKUP) {
                    this.propertyZonings.push((JSON.parse(lookup.content)).value);
                }
            });
            this.changeDetectorRef.detectChanges();
        });
    }
    static ctorParameters = () => [
        { type: PropertySearchService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        advancedSearchOccurred: [{ type: Output }]
    };
};
PropertiesSearchZoningComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-properties-search-zoning",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], PropertiesSearchZoningComponent);
export { PropertiesSearchZoningComponent };
